import { faCheckCircle, faFile, faFileAlt, faFolder, faFolderOpen } from '@fortawesome/free-regular-svg-icons';
import { faAngleDown, faCheck, faHome, faInfoCircle, faSearch, faSearchDollar, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFileLines, faFileVideo, faFilePdf, faFileImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { useDropzone } from "react-dropzone";
import { Card, CardBody, CardFooter, Tooltip, UncontrolledTooltip, UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu, Button } from 'reactstrap';
import 'antd/dist/reset.css';
import { Popover as AntdPopover, Dropdown as AntDropDown, Col, DatePicker, Form, Input, message, Row, Select, TreeSelect } from "antd";
import './workdrive.css'
import swal from "sweetalert"
import Loading from '../../common/loader';
import icon from '../../assets/images/zoho-Workdrive-tr.png';
import Config from '../../config.json'
import ActivitieService from '../../common/util/ActivitieService';
import AppContext from '../../Context/AppContext';
import AwsServerService from '../../common/util/AwsServerService';
import { RightOutlined } from '@ant-design/icons';
import { useSelector } from "react-redux"; 
import WorkdrivePermissions from '../TaskBluePrints/SecurityControls/WorkdrivePermissions';
import CustomizeFolder from './CustomizeFolder';
import { string } from 'mathjs';
import { Modal } from "antd";
import EmailService from '../../common/util/EmailService';
import dayjs from 'dayjs';
import WorkDriveUI from '../../navbar/WorkDriveUI';
//

const Workdrive = (props) => {
    const backendUrl = Config.backend_aws_server_url;
    // axios.defaults.proxy.host = "https://www.zohoapis.com"
    const moduleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
    const userInfo = JSON.parse(localStorage.getItem("userinfo")); 
    const [allFiles, setAllFiles] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [loaderState, setLoaderState] = useState([]);
    const AppData = useContext(AppContext);
    const { state, dispatch } = AppData || {};
    const [uploadFiles, setUploadFiles] = useState([]);
    const [parent_id, setParentId] = useState("inifpd9a80f1f19df4d5e95e45375c41509f1"); 
    const [openFolderDir, setOpenFolderDir] = useState([]);
    const [folderInfo, setFolderInfo] = useState({});
    const [createFolder, setCreateFolder] = useState(false);
    const [folderName, setFolderName] = useState(null);
    const [error, setError] = useState(null);
    const [folderId, setFolderId] = useState("inifpd9a80f1f19df4d5e95e45375c41509f1");
    const [hoverId, setHoverId] = useState("");
    const [token, setToken] = useState(localStorage.getItem('token'))// useState("Bearer 1000.61582af6a582dd94c8c493d846639e6f.17c793a7a5f75b8b0f972644d6399a1e");
    const [tokenTime, setTokenTime] = useState(new Date());

    const [copyState, setCopyState] = useState(false);
    const [moveState, setMoveState] = useState(false);
    const [moveFiles, setMoveFiles] = useState([]);
    const [fromMoveFolderId, setFromMoveFolderId] = useState("");
    const [searchState, setSearchState] = useState(false);
    const [searchFiles, setSearchFiles] = useState([]);
    const [searchText, setSearchText] = useState(null);
    const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone();

    const [shareOpen, setShareOpen] = useState(false);
    const [shareExternally, setShareExternally] = useState(false);
    const [dragDisabled, setDragDisabled] = useState(true);
    const dragRef = useRef(null);
    const [confirmToTrash, setConfirmToTrash] = useState(false)
    
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [permission, setPermission] = useState(null);
    const [linkName, setLinkName] = useState("");
    const [expiryDate, setExpiryDate] = useState(dayjs().add(14, "day"));

    const userOptions = Array.from(
        new Map(
            Object.values(moduleContacts)
            .flat()
            .map((item) => {
                const email = item.Email;
                const name = item.Full_Name || item.name || email;

                return [
                email, // key for uniqueness
                {
                    label: `${name} (${email})`,
                    value: email,
                    name: name
                },
                ];
            })
        ).values()
    );

const [activeFile, setActiveFile] = useState(null);
const handleDownload = (file) =>{
    const url = file.attributes.download_url;
    const fileName = file.attributes.name || "download";

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
const isWidePreview = activeFile && ["pdf", "txt"].includes(activeFile.attributes.extn);
const renderPreview = (file, type) => {
    const url = file.attributes.download_url;
    const ext = file.attributes.extn;
    
    if (["png", "jpg", "jpeg", "gif", "webp"].includes(ext)) {
        return (
            <img
                src={url}
                style={{
                    maxWidth: "90%",
                    maxHeight: "75vh",
                    objectFit: "contain"
                }}
            />
        );
    }

    if (["mp4", "webm"].includes(ext)) {
        return (
            <video
                src={url}
                controls
                style={{ maxWidth: "90%", maxHeight: "75vh" }}
            />
        );
    }

    if (ext === "pdf" || ext === "txt") {
        if(type == "preview"){
            return "Cant preview please click to download..."
        } else {
            return (
                <iframe
                    src={file.attributes.permalink}
                    style={{
                        width: "100%",
                        height: "85vh",
                        border: "none"
                    }}
                    title="PDF Preview"
                />
            );
        }
    }

};
const [generatedLink, setGeneratedLink] = useState("");
const [generatedLinkId, setGeneratedLinkId] = useState("")
const handleShare = async () => {
    setLoaderState(true)
    let shareUrl;
    await AwsServerService.shareLinkExternally(selectedItems[0].id, permission, linkName, expiryDate, token).then(res =>{
        setGeneratedLinkId(res?.data?.data?.id)
        shareUrl = res?.data?.data?.attributes?.link;
        setGeneratedLink(res?.data?.data?.attributes?.link)
        message.success("Link created successfully")
        setLoaderState(false)
    })
    
  };
  
  const handleSendEmail = async () =>{
    const expiration = new Date(expiryDate)
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");
    const payLoad = {
        FolderId: selectedItems[0].id,
        LinkId: generatedLinkId,
        Users: JSON.stringify(selectedUsers),
        ExpirationDate: expiration,
        CREATEDBY: userInfo.email_id
    };
    const abc = payLoad
    await AwsServerService.AddUserToLink(payLoad).then()
    if(generatedLink){
        await EmailService.GetCurrentEmailAccount(userInfo?.email_id).then( async result => {
            for (const user of selectedUsers) {
                const emailContent = `
                <div>
                    <p>Hello, ${user.label.split(' (')[0]}</p>
                    <p>You have been given access to a shared link.</p>
                    <p><b>Name:</b> <a href="${generatedLink}">${linkName}</a></p><a src={}></>
                    <p><b>Expires On:</b> ${expiryDate?.format("YYYY-MM-DD")}</p>
                    <br/>
                    <p>Regards,<br/>Your Team</p>
                </div>
                `;
                const emailPayload = {
                    fromAddress: userInfo?.email_id,
                    toAddress: user.value,
                    subject: `Shared Link: ${linkName}`,
                    askReceipt: "no",
                    content: emailContent,
                    mailFormat: "html",
                };
                // if (cc) emailPayload.ccAddress = cc;
                // if (bcc) emailPayload.bccAddress = bcc;
                await EmailService.SendEmail(result?.data[0]?.accountId, emailPayload);
                setExpiryDate(dayjs().add(14, "day"));
                setLinkName("");
                setSelectedUsers([]);
                setPermission(null);
                // setSelectedFiles(prev => {
                //     const selectedIds = selectedItems.map(item => item.id);
                //     return prev.filter(item => !selectedIds.includes(item.id));
                // });
            }
            message.success("Email Send Successfully")
            setGeneratedLinkId("")
            setGeneratedLink("")
        }).catch(error => {
            console.error("Error fetching email account:", error);
        });
        setLoaderState(false)
        setShareExternally(false);
    }
  };
    let timer = null;
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
            clearSelection();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [selectedFiles]);
    useEffect(() => {
        if (props.data && props.data.zohoworkdriveforcrm__Workdrive_Folder_ID) {
            setTimeout(() => {
                setFolderId(props.data.zohoworkdriveforcrm__Workdrive_Folder_ID);
                setParentId(props.data.zohoworkdriveforcrm__Workdrive_Folder_ID);
            }, 500);
        }
    }, [props.data])
    useEffect(()=>{
     if(props.data.Deal_Name){
        AwsServerService.getRelativePath(props.data.Deal_Name,props.module).then(res=>{
            let path=res.data[0];
            props.setRelativePathId(path.RelativePath);
        })
     }
    },[props.data])
    // useEffect(() => {
    //     getToken()
    // }, [])
    useEffect(() => {

        if (acceptedFiles.length > 0) {
            handleFileAttachments(acceptedFiles);
        }
    }, [acceptedFiles])

    useEffect(() => {
        if (uploadFiles.length > 0) {
            handleAllFileUpload(uploadFiles);
        }
    }, [uploadFiles])

   const rootDirName = useRef("");

    useEffect(()=>{
        getRootFolderName()
        teamFolderPermissions()
    },[])

     const getRootFolderName = async () => {
        await AwsServerService.fetchFolderInfo(
            "4snndf1add4f710e14016ba6eb3d69bacb086", localStorage.getItem("token"),
        ).then(res =>{
            rootDirName.current=res?.data?.data?.attributes?.name;
        });
    };
    const [teamMembers, setTeamMembers] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false)
    const teamFolderPermissions = async () => {
        await AwsServerService.fetchFolderMembers(
            "4snndf1add4f710e14016ba6eb3d69bacb086", localStorage.getItem("token"),
        ).then(res =>{
            setTeamMembers(res?.data?.data);
            const userData = res?.data?.data.filter(item =>item?.attributes?.email_id == userInfo?.email_id)
            setIsAdmin(userData[0]?.attributes?.role_id == 1 ? true : false)
        });
    };

    // useEffect(() => {
    //     window.ZOHO.embeddedApp.on('PageLoad', function (data1) {

    //         window.ZOHO.CRM.API.getRecord({ Entity: data1.Entity, RecordID: data1.EntityId })
    //             .then((result) => {

    //                 let deal = result.data[0];
    //                 setFolderId(deal.zohoworkdriveforcrm__Workdrive_Folder_ID);
    //                 setParentId(deal.zohoworkdriveforcrm__Workdrive_Folder_ID);

    //                 // return  window.ZOHO.CRM.API.getRecord({ Entity: "Accounts", RecordID:  deal.Account_Name.id })
    //             })
    //             // .then((result)=>{
    //             //     console.log(result)
    //             //     let account = result.data[0];
    //             //     console.log(account)
    //             //     console.log(account.zohoworkdriveforcrm__Workdrive_Folder_ID);
    //             //     setFolderId(account.zohoworkdriveforcrm__Workdrive_Folder_ID);
    //             //      setParentId(account.zohoworkdriveforcrm__Workdrive_Folder_ID);
    //             // })
    //             .catch((Err) => {
    //                 console.log(Err);
    //             })
    //     })
    //     window.ZOHO.embeddedApp.init();
    // }, [])

    useEffect(() => {
        if (folderId && token) { 
            getHomeData(folderId); 
            // if (openFolderDir.length > 0 || props.getRelativePath) {
            //     let path = '/';
            //     openFolderDir.forEach((one) => {
            //         path = path + one.name
            //     }
            //     )

            //     props.getRelativePath(path+'/')
            // } else {
            //     if(props.getRelativePath){
            //         props.getRelativePath("/")
            //     }
            // }
        }
    }, [folderId, token])

    useEffect(() => {
        if (openFolderDir.length > 0 && props.getRelativePath) {
            let path = '/';
            openFolderDir.forEach((one) => {
                path = path + one.name + '/'
            }
            )

            props.getRelativePath(path, openFolderDir[openFolderDir.length - 1].name)
        } else {
            if (props.getRelativePath) {
                props.getRelativePath("/", 'none')
            }
        }
    }, [openFolderDir])
 
    const selectedItems = selectedFiles?.filter(one => one?.checked) || [];
    useEffect(() => {
        if (selectedItems.length === 0) {
            setShareOpen(false);
        }
    }, [selectedItems]);

    const getHomeData =async (id) => {
        var config = {
            Type: "Get",
            url: "https://www.zohoapis.com/workdrive/api/v1/files/" + id + "/files",
            method: "GET",
            headers: {
                'Authorization': token
            }
        };
        setLoaderState(true)
        if(props.module=='Task'){
           await axios.post(backendUrl + "catalyApi/workdrive", { config: config })
            .then(async function (response) {
                let responseData=response.data.data;
                let isFolderExist=false;
                for (let index = 0; index < responseData?.length; index++) {
                    if(responseData[index].attributes.type=='folder' && responseData[index].attributes.name=='Documents'){
                        isFolderExist=true;
                    }
                }
                if(props.data.zohoworkdriveforcrm__Workdrive_Folder_ID==parent_id && parent_id==folderId && !isFolderExist){
                    var config = {
                        Type: "Create",
                        data: {
                            attributes: {
                                name: "Documents",
                                parent_id: folderId
                            },
                            type: "files"
                        },
                        url: "https://www.zohoapis.com/workdrive/api/v1/files",
                        method: "POST",
                        headers: {
                            'Authorization': token
                        }
                    };
                    await axios.post(backendUrl +"catalyApi/workdrive", { config: config }).then(async res=>{
                        let resData=res.data.data;
                        responseData=responseData.concat(resData)
                        var config = {
                            Type: "Create",
                            data: {
                                attributes: {
                                    name: "Task",
                                    parent_id: resData.id
                                },
                                type: "files"
                            },
                            url: "https://www.zohoapis.com/workdrive/api/v1/files",
                            method: "POST",
                            headers: {
                                'Authorization': token
                            }
                        };
                        await axios.post(backendUrl +"catalyApi/workdrive", { config: config }).then(async rData=>{ 
                            let relativePath=rData.data.data.id;
                            let DealName=props.data.Deal_Name;
                            let module=props.module;
                        await AwsServerService.saveRelativePath({DealName:DealName,Module:module,RelativePath:relativePath}).then(r=>{
                            props.setRelativePathId(relativePath);
                        }).catch(er=>{console.log(er);
                        })
                        setLoaderState(false);
                        setAllFiles(responseData);
                        setSelectedFiles(responseData);
                        }).catch(err=>{
                        setLoaderState(false);
                        setAllFiles(response.data.data);
                        setSelectedFiles(response.data.data)
                        })
                    }).catch(err=>{
                        setLoaderState(false);
                        setAllFiles(response.data.data)
                        setSelectedFiles(response.data.data)
                    })
                }
                setLoaderState(false);
                setAllFiles(response.data.data)
                setSelectedFiles(response.data.data)
            })
            .catch(function (error) {
                setLoaderState(false);
                console.log(error);
            });
        }else{
        axios.post(backendUrl + "catalyApi/workdrive", { config: config })
            .then(function (response) {
                setLoaderState(false);
                setAllFiles(response.data.data)
                setSelectedFiles(response.data.data)
            })
            .catch(function (error) {
                setLoaderState(false);
                console.log(error);
            });
        }
    }

    const handleFileAttachments = async (fileList) => {
        let tempFileCollection = [...uploadFiles];
        let v = fileList.length;
        let index = 0;
        while (index < v) {
            let fileName = fileList[index].name;
            let type = fileList[index].type;
            let base64 = await convertToBase64(fileList[index]);
            tempFileCollection.push({
                fileName: fileName,
                file: base64,
                type: type
            });
            index = index + 1;
        }
        setUploadFiles(tempFileCollection);

    };

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const createFolderZoho = () => {
        var config = {
            Type: "Create",
            data: {
                attributes: {
                    name: folderName,
                    parent_id: folderId
                },
                type: "files"
            },
            url: "https://www.zohoapis.com/workdrive/api/v1/files",
            method: "POST",
            headers: {
                'Authorization': token
            }
        };
        setLoaderState(true);
        axios.post(backendUrl + "catalyApi/workdrive", { config: config })
            .then(function (response) {
                if (openFolderDir.length > 0) {
                    getFolderAndFilesOfId(openFolderDir[openFolderDir.length - 1].id);
                } else {
                    getFolderAndFilesOfId(folderId);
                }

                setCreateFolder(false)
                setLoaderState(false);
                setError(null);
                setFolderName(null)
            })
            .catch(function (error) {
                setLoaderState(false);
                console.log(error);
            });
    }

    const handleCreateFolder = () => {
        if (folderName) {
            if (selectedFiles && selectedFiles.filter(one => one.attributes.name.toLowerCase() == folderName.trim().toLowerCase()).length > 0) {
                swal({
                    title: "Folder name already exist?",
                    text: "Do you want to create?",
                    icon: "warning",
                    buttons: ["No", "Yes"],
                    dangerMode: true,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            createFolderZoho();
                        } else {
                            // No
                        }
                    });
            } else {
                createFolderZoho();
            }


        } else {
            setError({ error: "please enter a valid folder name" })
            // swal("please enter folder name", { dangerMode: true });
        }

    }

    const getTokenEndTime = (start) => {
        let end = new Date(start);
        end.setTime(end.getTime() + (3600 * 1000))
        return new Date(end);
    }


    const getToken = () => {
        let obj = {
            "access_token": "1000.b363472952cbfa446395094862c69e44.ef963f387bd2837504ddbb8d65080690",
            "refresh_token": "1000.76b425e85e8d6f89a1840bd939283b8b.3e2b2418b377941c1f83e73a6856ec5f",
            "scope": "ZohoFiles.files.READ TeamDrive.files.READ TeamDrive.files.CREATE TeamDrive.files.UPDATE TeamDrive.files.DELETE ZohoCRM.users.READ ZohoCRM.users.CREATE ZohoCRM.users.UPDATE ZohoCRM.users.DELETE ZohoSearch.securesearch.READ TeamDrive.team.READ ZohoCRM.modules.READ ZohoCRM.modules.CREATE ZohoCRM.modules.UPDATE ZohoCRM.modules.DELETE",
            "api_domain": "https://www.zohoapis.com",
            "token_type": "Bearer",
            "expires_in": 3600
        }
        axios.get(backendUrl + "token/" + obj.refresh_token)
            .then((result) => {
                setToken("Bearer " + result.data.access_token);
                let start = new Date(result.data.tokenTime);
                setTokenTime(start)
                clearInterval(timer);
                timer = setInterval(() => {
                    let time = new Date(tokenTime);
                    var minutes = ((getTokenEndTime(start).getTime() - tokenTime.getTime()) / 1000) / 60;
                    if (minutes <= 15) {
                        getToken()
                    }
                    time.setMinutes(time.getMinutes() + 1);
                    setTokenTime(time);
                }, (60 * 1000))
            })
            .catch((err) => {
                getToken()
                //alert(JSON.stringify(err));
            })
    }

    const getFolderHerriarchi = (id) => {
        return new Promise((resolve, reject) => {
            var config = {
                Type: "Get",

                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + id + "/files",
                method: "GET",
                headers: {
                    'Authorization': token
                }
            };
            setLoaderState(true);
            axios.post(backendUrl + "catalyApi/workdrive", { config: config })
                .then((result) => {
                    setLoaderState(false);
                    result.data.data = result.data.data.filter(one => one.attributes.type == 'folder');
                    resolve(result.data.data);
                })
                .catch((err) => {
                    setLoaderState(false);
                    reject(err)
                })
        })
    }

    let arr = []
    const getFolderDirForSearch = async (id, selectedId) => {
        let res = await getFolderHerriarchi(id);
        for (let i = 0; i < res.length; i++) {
            let filter = res.filter(one => one.id == selectedId);
            if (filter.length > 0) {
                arr.push({ id: filter[0].id, name: filter[0].attributes.name });
                break;
            } else {
                arr.push({ id: res[i].id, name: res[i].attributes.name });
                await getFolderDirForSearch(res[i].id, selectedId);
            }
            res = await getFolderHerriarchi(res[i].id)
        }
        const arrayUniqueByKey = [...new Map(arr.map(item =>
            [item["id"], item])).values()];
        setSearchState(false);
        setSearchText(null);
        setFolderId(selectedId);
        setOpenFolderDir(arrayUniqueByKey);
    }


    const getFolderAndFilesOfId = (id, name, operation) => {
        var config = {
            Type: "Get", 
            url: "https://www.zohoapis.com/workdrive/api/v1/files/" + id + "/files",
            method: "GET",
            headers: {
                'Authorization': token
            }
        };
        setLoaderState(true);
        axios.post(backendUrl + "catalyApi/workdrive", { config: config })
            .then(async function (response) {
                let dir = [...openFolderDir]
                if (operation == "next") {
                    dir.push({ name: name, id: id })
                    setOpenFolderDir(dir);
                } else if (operation == "back") {
                    let arr = []
                    for (let i = 0; i < dir.length; i++) {
                        arr.push(dir[i]);
                        if (id == dir[i].id) {
                            break;
                        }
                    }
                    setOpenFolderDir(arr);
                    dir.pop({ name: name, id: id });
                }
                else if (operation == "search") {
                    setOpenFolderDir([]);
                }
                setLoaderState(false);
                setSelectedFiles(response.data.data)
            })
            .catch(function (error) {
                setLoaderState(false);
                console.log(error);
            });
    }

    const handleCheckItem = (e, index) => {
        const files = [...selectedFiles];
        let obj = files[index];
        obj.checked = e.currentTarget.checked;
        if(!obj.checked){
            obj.rename = false
            files[index] = obj;
            setAllFiles(files)
            setSelectedFiles(files)
        } else {
        files[index] = obj;
        setAllFiles(files)
        setSelectedFiles(files)
        }
    }

    const handleRenameAll = () => {
        let files = selectedFiles.filter(one => one.checked && one.rename && one.renameValue);
        let withoutRenameFiles = selectedFiles.filter(one => !one.checked);
        let doArr = []
        let fileNameExist = files.filter(one => {
            if (withoutRenameFiles.filter(f => f.attributes.name.toLowerCase() == one.renameValue.trim().toLowerCase()).length > 0) {
                return one;
            }
        });
        if (fileNameExist.length > 0) {
            let text = "";
            fileNameExist.forEach(file => {
                text = text + file.renameValue + ",";
            })
            text = text + " folder or file name already exist! Please use different name."
            swal(text, { dangerMode: true });
        } else {
            files.forEach((one) => {
                doArr.push(handleRenameFolder(one))
            })
            Promise.all(doArr)
                .then((result) => {
                    if (openFolderDir.length > 0) {
                        let obj = openFolderDir[openFolderDir.length - 1]
                        getFolderAndFilesOfId(obj.id, obj.name, "same");
                    } else {
                        getHomeData(parent_id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }


    }

    const handleRenameFolder = () => {
        let files = selectedFiles.filter(one => one.checked && one.rename && one.renameValue);
        return new Promise((resolve, reject) => {

            var config = {
                Type: "Rename",
                data: {
                    attributes: {
                        name: files[0].renameValue,
                    },
                    type: "files"
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + string(selectedItems[0].id),
                method: "PATCH",
                headers: {
                    'Authorization': token
                }
            };
            setLoaderState(true);
            axios.post(backendUrl + "catalyApi/workdrive", { config: config })
                .then(function (response) {
                    setLoaderState(false);
                    selectedFiles.forEach(one => {
                        if (one.checked) one.rename = false;
                    });
                    if (openFolderDir.length > 0) {
                        let obj = openFolderDir[openFolderDir.length - 1]
                        getFolderAndFilesOfId(obj.id, obj.name, "same");
                    } else {
                        getHomeData(parent_id);
                    }
                    resolve(response)
                })
                .catch(function (error) {
                    setLoaderState(false);
                    reject(error);
                });
        })

    }


    const handleDeleteAll = () => {
        let files = selectedFiles.filter(one => one.checked);
        let doArr = []
        files.forEach((one) => {
            doArr.push(handleDeleteFolder(one))
        })
        setLoaderState(true);
        Promise.all(doArr)
            .then((result) => {
                if (openFolderDir.length > 0) {
                    let obj = openFolderDir[openFolderDir.length - 1]
                    getHomeData(obj.id);
                    // setOpenFolderDir([])
                } else {
                    getHomeData(parent_id);
                }
                setLoaderState(false);

                // setOpenFolderDir([]);
            })
            .catch((err) => {
                setLoaderState(false);
                console.log(err);
            })
    }

    const handleDeleteFolderPermanent = (data) => {
        return new Promise((resolve, reject) => {
            var config = {
                Type: "Delete",
                data: {
                    attributes: {
                        status: "61",
                    },
                    type: "files"
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + data.id,
                method: "PATCH",
                headers: {
                    'Authorization': token
                }
            };
            setLoaderState(true);
            axios.post(backendUrl + "catalyApi/workdrive", { config: config })
                .then(async function (response) {
                    setLoaderState(false);
                    resolve(response)
                })
                .catch(function (error) {
                    setLoaderState(false);
                    reject(error);
                });
        })

    }


    const handleDeleteFolder = (data) => {
        return new Promise((resolve, reject) => {
            var config = {
                Type: "Delete",
                data: {
                    attributes: {
                        status: "51",
                    },
                    type: "files"
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + data.id,
                method: "PATCH",
                headers: {
                    'Authorization': token
                }
            };
            setLoaderState(true);
            axios.post(backendUrl + "catalyApi/workdrive", { config: config })
                .then(async function (response) {
                    await handleDeleteFolderPermanent(data);
                    setLoaderState(false);
                    resolve(response)
                })
                .catch(function (error) {
                    setLoaderState(false);
                    reject(error);
                });
        })

    }

    const handleAllFileUpload = (uploadFile) => {
        let files = [...uploadFile];
        if (files.length > 0) {
            let doArr = []
            files.forEach((one) => {
                doArr.push(handleUploadFile(one))
            })
            setLoaderState(true);
            Promise.all(doArr)
                .then((result) => {
                    if (openFolderDir.length > 0) {
                        let obj = openFolderDir[openFolderDir.length - 1]
                        getHomeData(obj.id);
                        // setOpenFolderDir([])
                    } else {
                        getHomeData(parent_id);
                    }
                    setLoaderState(false);
                    // setOpenFolderDir([]);
                })
                .catch((err) => {
                    setLoaderState(false);
                    console.log(err);
                })
        }

    }


    const handleUploadFile = (fileObj) => {
        return new Promise((resolve, reject) => {


            var config = {
                Type: "Upload",
                data: {
                    filename: fileObj.fileName,
                    content: fileObj.file,
                    parent_id: folderId,
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/upload",
                method: "POST",
                headers: {
                    'Authorization': token
                }
            };
            setLoaderState(true);
            let res = {}
            axios.post(backendUrl + "catalyApi/workdrive", { config: config })
                .then(function (response) {
                    res = response
                    return ActivitieService.AddActivityLocal('Workdrive', { DealId: props.data.Project_ID }, { action_type: 'Upload', data_type: 'File', data: { name: fileObj.fileName } })
                })
                .then((result) => {
                    setLoaderState(false);
                    resolve(res)
                })
                .catch(function (error) {
                    setLoaderState(false);
                    reject(error);
                });
        })

    }

    const handleCopyAll = () => {
        let files = [...moveFiles];
        let doArr = []
        files.forEach((one) => {
            doArr.push(handleCopyFile(one))
        })
        setLoaderState(true);
        Promise.all(doArr)
            .then((result) => {
                if (openFolderDir.length > 0) {
                    let obj = openFolderDir[openFolderDir.length - 1]
                    getHomeData(obj.id);
                    // setOpenFolderDir([])
                } else {
                    getHomeData(parent_id);
                }
                setLoaderState(false);
                setMoveFiles([]);
                setCopyState(false);
                // setOpenFolderDir([]);
            })
            .catch((err) => {
                setLoaderState(false);
                console.log(err);
            })
    }

    const handleCopyFile = (data) => {
        return new Promise((resolve, reject) => {
            var config = {
                Type: "Copy",
                data: {
                    attributes: {
                        resource_id: data.id
                    },
                    type: "files"
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + folderId + "/copy",
                method: "POST",
                headers: {
                    'Authorization': token
                }
            };
            setLoaderState(true);
            axios.post(backendUrl + "catalyApi/workdrive", { config: config })
                .then(function (response) {
                    setLoaderState(false);
                    resolve(response)
                    if (response.data.errors && response.data.errors.length > 0) {
                        swal(response.data.errors[0].title, { dangerMode: true })
                    }

                })
                .catch(function (error) {
                    setLoaderState(false);
                    reject(error);
                });
        })
    }


    const handleSearchFile = (e) => {
        const value = e.target.value;
        setSearchText(value);

        if (!value) {
            setSelectedFiles(allFiles); // reset to full list
            return;
        }

        const filtered = allFiles.filter(item =>
            item?.attributes?.name?.toLowerCase().includes(value.toLowerCase())
        );

        setSelectedFiles(filtered);

    }

    const handleDownloadAllFile = () => {
        let files = selectedFiles.filter(one => one.checked);
        if (files.length > 0) {
            let doArr = []
            if (files.length == 1) {
                handleDownloadFileAndFolder(files[0]);
            } else {
                let ids = []
                files.forEach((one) => {
                    ids.push(one.id);
                })

                handleDownloadFileAndFolderOneZip(ids);

            }

        }
    }

    const handleDownloadFileAndFolderOneZip = (ids) => {
        var config = {}
        ids = ids.join(",")
        config = {
            Type: "Download",
            FileType: "Folder",
            data: {
                attributes: {
                    resource_id: ids
                },
                type: "files"
            },
            url: "https://www.zohoapis.com/workdrive/api/v1/multizip",
            method: "POST",
            headers: {
                'Authorization': token
            }
        };


        setLoaderState(true);
        axios.post(backendUrl + "catalyApi/workdrive", { config: config })
            .then(async function (response) {
                response = await axios.post(backendUrl + "catalyApi/workdrive", { config: config })
                let link = document.createElement('a');
                link.setAttribute('href', response.data.download_link);
                link.setAttribute('download', "test");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoaderState(false);

            })
            .catch(function (error) {
                setLoaderState(false);
                // reject(error);
            });

    }



    const handleDownloadFileAndFolder = (one) => {
        var config = {}
        if (one.attributes.type == 'folder') {
            config = {
                Type: "Download",
                FileType: "Folder",
                data: {
                    attributes: {
                        resource_id: one.id
                    },
                    type: "files"
                },
                url: "https://www.zohoapis.com/workdrive/api/v1/multizip",
                method: "POST",
                headers: {
                    'Authorization': token
                }
            };
        } else {
            config = {
                Type: "Download",
                FileType: "File",
                url: "https://download.zoho.com/v1/workdrive/download/" + one.id,
                method: "GET",
                data: {},
                headers: {
                    'Authorization': token
                }
            };
        }


        setLoaderState(true);
        axios.post(backendUrl + "catalyApi/workdrive", { config: config })
            .then(async function (response) {
                // resolve(response)
                // let url = window.URL.createObjectURL(response.data.download_link)
                if (one.attributes.type == 'folder') {
                    response = await axios.post(backendUrl + "catalyApi/workdrive", { config: config })
                    let link = document.createElement('a');
                    link.setAttribute('href', response.data.download_link);
                    link.setAttribute('download', "test");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    let url = "https://download.zoho.com/v1/workdrive/download/" + one.id;
                    let link = document.createElement('a');
                    link.setAttribute('href', url);
                    link.setAttribute('download', one.attributes.name);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }

                // setSelectedFiles(response.data.data)
                setLoaderState(false);

            })
            .catch(function (error) {
                setLoaderState(false);
                // reject(error);
            });

    }

    const handleMoveAll = () => {
        let files = [...moveFiles];
        let doArr = []
        files.forEach((one) => {
            doArr.push(handleMoveFileOrFolder(one))
        })
        Promise.all(doArr)
            .then((result) => {
                if (openFolderDir.length > 0) {
                    let obj = openFolderDir[openFolderDir.length - 1]
                    getHomeData(obj.id);

                    // setOpenFolderDir([])
                } else {
                    getHomeData(parent_id);
                }
                setMoveState(false);
                setMoveFiles([])
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleMoveFileOrFolder = (data) => {
        return new Promise((resolve, reject) => {
            var config = {
                Type: "Move",
                data: {
                    attributes: {
                        parent_id: folderId
                    },
                    type: "files"

                },
                url: "https://www.zohoapis.com/workdrive/api/v1/files/" + data.id,
                method: "PATCH",
                headers: {
                    'Authorization': token
                }
            };
            axios.post(backendUrl + "catalyApi/workdrive", { config: config })
                .then(function (response) {
                    resolve(response)
                })
                .catch(function (error) {
                    reject(error);
                });
        })
    }


    const getDisableState = () => {
        if (moveState) {
            return fromMoveFolderId == folderId || (moveFiles.filter(one => one.id == folderId).length > 0)
        } else if (copyState) {
            return (moveFiles.filter(one => one.id == folderId).length > 0)
        } else {
            return false;
        }
    }
    const handleSelectAll = (e) => {
        const checked = e.target.checked;

        const updatedFiles = selectedFiles.map(file => ({
            ...file,
            checked: checked
        }));
        setAllFiles(updatedFiles)
        setSelectedFiles(updatedFiles);
    };
    const clearSelection = () => {
        const updatedFiles = selectedFiles.map(file => ({
            ...file,
            checked: false,
            rename: false
        }));
        setAllFiles(updatedFiles)
        setSelectedFiles(updatedFiles);

        setMoveState(false);
        setCopyState(false);
        setMoveFiles([]);
    };
    const handleCopyLink = async () => {
        let link = Array.isArray(selectedItems) && selectedItems.length > 0
                    ? selectedItems
                        .map(item => item?.attributes?.permalink)
                        .filter(Boolean) // remove undefined/null
                        .join("\n")
                    : "";
        // selectedItems.length > 1 
        //             ? selectedItems.map(item => item.attributes?.permalink).join("\n")
        //             : selectedItems?.[0]?.attributes?.permalink;

        if (!link) {
            message.warning("No link available");
            return;
        }

        try {
            await navigator.clipboard.writeText(link);
            message.success(selectedItems.length+" Link copied to clipboard");
        } catch (err) {
            console.error(err);
            message.error("Failed to copy link");
        }
    };
    const handleMoveToTrash = () => {
        AwsServerService.moveToTrash(selectedItems, localStorage.getItem("token")).then(res =>{
            setSelectedFiles(prev => {
                const selectedIds = selectedItems.map(item => item.id);
                return prev.filter(item => !selectedIds.includes(item.id));
            });
            message.success(selectedItems.length+" Item moved to trash");
        }).catch(error =>{
            console.log("got exception while moveing item to trash",error)
        })
    }
    return (<>
        <WorkDriveUI openFolderDir={openFolderDir} folderInfo={folderInfo} rootDirName={rootDirName.current}/>
        <div className={isDragActive ? "drag-overlay" : ""} style={{marginTop:"-20px"}}>

            {isDragActive ?

                <div className='drop-file'><FontAwesomeIcon size='2x' icon={faFile} />&nbsp;&nbsp;&nbsp;darg files here</div> :

                <></>}

            <div style={isDragActive ? { opacity: .3 } : {  }} >
                <div   className='container1 mt-2 px-3 pt-2'>
                    {loaderState ? <Loading /> : <></>}
                <div className='workdrive-heading-box'
                        style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 15px", marginLeft:"-8px"}}
                    >
                        <div className="left-icons"
                            style={{display:"flex", gap:"10px"}}
                        >
                            <div className="input-search-wrapper" style={{ position: "relative" }}>

                                <div
                                    className="search-icon-wrapper"
                                    style={{
                                        position: "absolute",
                                        left: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        pointerEvents: "none"
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faSearch} style={{ color: "#888", fontSize: "12px" }}
                                    />
                                </div>

                                <input
                                    type="text"
                                    placeholder="Search file and folder"
                                    value={searchText ? searchText : ""}
                                    onChange={handleSearchFile}
                                    className="form-control form-control-sm"
                                    style={{  width: "17rem", borderColor: "#018EE0", paddingLeft: "30px",  paddingRight: "28px" }}
                                />

                                {searchText && (
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        onClick={() => {
                                            setSearchText(null);
                                            setSearchState(false);
                                            getHomeData(parent_id);
                                        }}
                                        style={{ position: "absolute", right: "10px", top: "50%",
                                            transform: "translateY(-50%)", cursor: "pointer", color: "#999", fontSize: "12px"
                                        }}
                                    />
                                )}
                            </div>

                            <div className='icons-box2'>
                                <img style={{ width: "50px", height: "51px", cursor: 'pointer', margin: '-10px 0px -10px' }} onClick={() => window.open("https://workdrive.zoho.com/folder/" + folderId)} src={icon} />
                                {/* {/ <FontAwesomeIcon style={{ cursor: 'pointer' }} onClick={() => window.open("https://workdrive.zoho.com/folder/" + folderId)} color='#0d6efd' size='2x' icon={faFolderOpen} /> /} */}
                            </div>

                            {
                                <WorkdrivePermissions
                                    // teamFolders = {teamFolders}
                                    folderId = {folderId}
                                    selectedFiles = {selectedFiles}
                                />
                            }
                        </div>
                        
                        <div className="right-actions" style={{ display: "flex", gap: "10px", alignItems: "center" }}>

                            <div className="creat-box2">

                                {!createFolder ? (
                                    <button
                                        onClick={() => setCreateFolder(true)}
                                        className="btn btn-sm btn-primary"
                                    >
                                        Create Folder
                                    </button>
                                ) : (
                                    <div className="input-group input-group-sm" style={{ width: "220px" }}>
                                        <input
                                            autoFocus
                                            onChange={(e) => {
                                                if (e.currentTarget.value === "") {
                                                    setFolderName(null);
                                                    setError({ error: "please enter a valid folder name" });
                                                } else {
                                                    setFolderName(e.currentTarget.value);
                                                    setError(null);
                                                }
                                            }}
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter name"
                                        />
                                        <div className="input-group-append">
                                            <button
                                                onClick={handleCreateFolder}
                                                className="btn btn-outline-secondary"
                                                type="button"
                                            >
                                                <FontAwesomeIcon color="green" icon={faCheck} />
                                            </button>

                                            <button
                                                onClick={() => {
                                                    setCreateFolder(false);
                                                    setFolderName(null);
                                                    setError(null);
                                                }}
                                                className="btn btn-outline-secondary"
                                                type="button"
                                            >
                                                <FontAwesomeIcon color="red" icon={faTimes} />
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {error && (
                                    <p className="small text-danger m-0">{error.error}</p>
                                )}
                            </div>

                            <div {...getRootProps({ /*className: "dropzone"*/ })}>
                                <input {...getInputProps()} />
                                <button className="btn btn-sm btn-primary">
                                    Upload File
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className='row  text-left '>
                        <div className="col">
                            <FontAwesomeIcon style={{color:"#2566e8"}} onClick={() => { getHomeData(parent_id); setOpenFolderDir([]); setFolderId(parent_id) }} icon={faHome} />
                            {openFolderDir.map(one => {
                                return <>&nbsp;<RightOutlined />&nbsp;<span style={{ cursor: 'pointer', color: "#5b6c97" }} onClick={() => getFolderAndFilesOfId(one.id, one.name, "back")}>{one.name}</span></>
                            })}
                        </div>

                    </div>
                </div>
                <div style={{ maxHeight: "calc(110vh - 270px)" ,overflowY:'scroll'}} {...getRootProps({ className: "dropzone", onClick: event => event.stopPropagation() })} className='container1  px-3 pt-0'>
                    <table className="table workdrive-table table-sm ">
                        <thead>
                            {selectedItems.length > 0 ? (
                                <tr className="selection-header-row">
                                
                                <th>
                                    <input type="checkbox"
                                    checked={
                                        selectedItems.length > 0 &&
                                        selectedItems.length === selectedFiles.length
                                    }
                                    ref={(el) => {
                                        if (el) {
                                        el.indeterminate =
                                            selectedItems.length > 0 &&
                                            selectedItems.length < selectedFiles.length;
                                        }
                                    }}
                                    onChange={handleSelectAll}
                                    />
                                </th>

                                <th colSpan="6">
                                    <div className="selection-header-content">

                                    <div className="selection-left">
                                        {selectedItems.length} selected
                                    </div>

                                    <div className="selection-middle">
                                        {(isAdmin && selectedItems.length < 2) && (
                                            <button className="btn btn-sm btn-outline-primary"
                                                onClick={() => setShareOpen(true)}
                                            >
                                                Share
                                            </button>
                                        )}
                                        {(isAdmin && selectedItems.length < 2) && (
                                            <button className="btn btn-sm btn-outline-primary"
                                                onClick={() => setShareExternally(true)}
                                            >
                                                Share Externally
                                            </button>
                                        )}

                                        <button className="btn btn-sm btn-outline-primary"
                                            onClick={handleCopyLink}
                                        >
                                            Copy link
                                        </button>
                                        {(isAdmin && selectedItems.length < 2) && (
                                        <>
                                            <button 
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => {
                                                    const files = [...selectedFiles];
                                                    files.forEach(one => {
                                                        if (one.checked) one.rename = true;
                                                    });
                                                    setSelectedFiles(files);
                                                    setMoveState(false);
                                                    setCopyState(false);
                                                }}>
                                                Rename
                                            </button>
                                        </>
                                        )}
                                        
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={handleDownloadAllFile}
                                        >
                                            Download
                                        </button>
                                        {isAdmin && (
                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                // onClick={handleMoveToTrash}
                                                onClick={() =>setConfirmToTrash(true)}
                                            >
                                                Move to Trash
                                            </button>
                                        )}

                                    </div>
                                    <div className="selection-right">
                                        <button className="btn btn-sm btn-outline-secondary" 
                                            onClick={clearSelection}>
                                            Esc ✕
                                        </button>
                                    </div>
                                    </div>
                                </th>
                                </tr>
                            ) : (
                                <tr>
                                <th>
                                    <input
                                    type="checkbox"
                                    checked={
                                        selectedItems.length > 0 &&
                                        selectedItems.length === selectedFiles.length
                                    }
                                    ref={(el) => {
                                        if (el) {
                                        el.indeterminate =
                                            selectedItems.length > 0 &&
                                            selectedItems.length < selectedFiles.length;
                                        }
                                    }}
                                    onChange={handleSelectAll}
                                    />
                                </th>
                                <th></th>
                                <th>Name</th>
                                <th>Created By</th>
                                <th>Created Time</th>
                                <th>Last Modified Time</th>
                                <th>Size</th>
                            </tr>
                            )}
                        </thead>
                        <tbody>
                            {selectedFiles && selectedFiles.map((one, index) => {
                                if(one?.attributes?.name?.includes("Archive")){
                                    return;
                                }
                                return <tr className={one.checked ? "row-selected" : ""}>
                                    <td ><input className="checkbox-cell" onChange={(e) => handleCheckItem(e, index)} checked={one.checked || false} type="checkbox" /></td>
                                    <td >{one.attributes.extn == "pdf" ? <FontAwesomeIcon icon={faFilePdf} />
                                        : one.attributes.extn == ("mp4" || "ewebm") ? <FontAwesomeIcon icon={faFileVideo} />
                                        : ["png", "jpg", "jpeg", "gif", "webp"].includes(one.attributes.extn) ? <FontAwesomeIcon icon={faFileImage } />
                                        : one.attributes.type == "folder" ? (
                                            <span onClick={()=>{
                                                setFolderInfo({name:one.attributes?.name,timestamp:new Date()})
                                            }}>
                                                <FontAwesomeIcon icon={faFolder} />
                                                {one.attributes.customized && <div style={{ marginLeft: 4, marginTop: -20 }}>*</div>}
                                            </span>
                                            )
                                        : <FontAwesomeIcon icon={faFileAlt} />}
                                        </td>
                                    <td>
                                        {one.checked && one.rename ? (
                                            <div className="input-group">
                                                <div style={{width:"78%"}}> 
                                                <input
                                                    onChange={(e) => {
                                                        const files = [...selectedFiles];
                                                        files.forEach(obj => {
                                                            if (obj.id == one.id) {
                                                                one.renameValue = e.currentTarget.value;
                                                            }
                                                        });
                                                        setSelectedFiles(files);
                                                    }}
                                                    defaultValue={one.attributes.name}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="enter name"
                                                    />
                                                </div>
                                                <div className="inputRenmaeIcons">
                                                <FontAwesomeIcon
                                                    className="input-icon danger"
                                                    onClick={() => {
                                                        const files = [...selectedFiles];
                                                        files.forEach(obj => {
                                                            if (obj.id == one.id) {
                                                                obj.rename = false;
                                                            }
                                                        });
                                                        setSelectedFiles(files);
                                                    }}
                                                    icon={faTimes}
                                                    />
                                                <FontAwesomeIcon
                                                    className="input-icon success"
                                                    onClick={handleRenameFolder}
                                                    icon={faCheck}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                {one.attributes.type == "folder" ? (
                                                    <AntdPopover
                                                        placement="topLeft"
                                                        content={
                                                            <div style={{ maxWidth: "300px", wordBreak: "break-word" }}>
                                                                {one.attributes.name}
                                                            </div>
                                                        }
                                                    >
                                                        <div
                                                            className="file-name-cell"
                                                            onClick={() => {
                                                                if (searchState) {
                                                                    arr = [];
                                                                    setFolderId(one.id);
                                                                    getFolderDirForSearch(parent_id, one.id);
                                                                } else {
                                                                    getFolderAndFilesOfId(one.id, one.attributes.name, "next");
                                                                    setFolderId(one.id);
                                                                }
                                                            }}
                                                        >
                                                            {one.attributes.name}
                                                        </div>
                                                    </AntdPopover>
                                                ) : (
                                                    <AntdPopover
                                                        placement="right"
                                                        trigger="hover"
                                                        open={hoverId === one.id}
                                                        onOpenChange={(open) => {
                                                            setHoverId(open ? one.id : null);
                                                        }}
                                                        content={
                                                            <div>
                                                                {renderPreview(one, "preview")}
                                                            </div>
                                                        }
                                                        width= {one.attributes.extn == "pdf" ? "400px": ""}
                                                        display={one.attributes.extn == "pdf" ? "none" : "block"}

                                                    >
                                                        <div
                                                            title={one.attributes}
                                                            className="file-name-cell"
                                                            onClick={() => {
                                                                    setActiveFile(one)
                                                                }
                                                            }
                                                        >
                                                            {one.attributes.name}
                                                        </div>
                                                    </AntdPopover>
                                                )}
                                            </>
                                        )}
                                    </td>
                                    <td>{one.attributes.created_by}</td>
                                    <td>{one.attributes.created_time}</td>
                                    <td>{one.attributes.modified_time}</td>
                                    <td>{one.attributes.storage_info.size}</td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                    <Modal
                        rootClassName={isWidePreview ? 'wide-pdf-preview' : 'pdf-view'}
                        open={!!activeFile}
                        onCancel={() => setActiveFile(null)}
                        footer={null}
                        width="auto"
                        centered
                    >
                        <div style={{ textAlign: "center" }}>
                            {activeFile && renderPreview(activeFile, "click")}
                        </div>
                    </Modal>
                    {shareOpen == true && (
                        <CustomizeFolder 
                            data = {selectedItems}
                            dragDisabled = {dragDisabled}
                            setDragDisabled = {setDragDisabled}
                            shareOpen = {shareOpen}
                            setShareOpen = {setShareOpen}
                            dragRef = {dragRef}
                            teamMembers = {teamMembers}
                        />
                    )}
                </div>
            </div>


        </div>
      <Modal
        styles={{left: "-40%"}}
        open={confirmToTrash}
        onCancel={() => setConfirmToTrash(false)}
        footer={null}
        centered
      >
        <div style={{ display: "flex", gap: "12px" }}>
          <div style={{ fontSize: "22px", color: "#81c5f0" }}><FontAwesomeIcon icon={faInfoCircle} /></div>

          <div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                marginBottom: "8px",
              }}
            >
              Move {selectedItems.length} items to trash?
            </div>

            <div style={{ fontSize: "14px", color: "#444", lineHeight: "1.6" }}>
              The selected {selectedItems.length} items will be moved to the Trash. You can restore or delete them anytime by accessing the 
              Trash folder.
              To access Trash, click <strong> Members {">"} Trash </strong>.
              <br />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                gap: "10px",
              }}
            >
              <button
                onClick={() => {
                  setConfirmToTrash(false);
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  setConfirmToTrash(false);
                  handleMoveToTrash();
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "6px",
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                Move To Trash
              </button>
            </div>
          </div>
        </div>
      </Modal>
      
      <Modal
        styles={{
            content: { left: "-20%" },
            body: { overflow: "visible" }
        }}
        open={shareExternally}
        onCancel={() => setShareExternally(false)}
        footer={null}
        centered
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div style={{ fontSize: "18px", fontWeight: "600" }}>
                External Share Link 📁{selectedItems[0]?.attributes?.name}
                </div>

                <Row gutter={8}>
                    <Col span={12}>
                        <div className="floating-field">
                        <span className="floating-label">Link Name</span>
                            <Input
                            placeholder="Link Name"
                            value={linkName}
                            onChange={(e) => setLinkName(e.target.value)}
                            />
                        </div>
                    </Col>

                    <Col span={12}>
                        <div className="floating-field">
                        <span className="floating-label">Expiration Date</span>
                            <DatePicker
                            style={{ width: "100%" }}
                            placeholder="Expiration Date"
                            value={expiryDate}
                            onChange={(date) => setExpiryDate(date)}
                            />
                        </div>
                    </Col>
                </Row>

                <Row gutter={8}>
                    <Col span={12}>
                        <div className="floating-field">
                        <span className="floating-label">Permission</span>
                            <Select
                            placeholder="Permission"
                            value={permission}
                            onChange={(val) => setPermission(val)}
                            style={{ width: "100%" }}
                            getPopupContainer={() => document.body}
                            options={[
                                { label: "Edit", value: 5 },
                                { label: "View", value: 34 },
                                { label: "Upload", value: 7 },
                            ]}
                            />
                        </div>
                    </Col>
                </Row>
                    <Row gutter={8}>
                        <Col span={12}></Col>
                        <Col span={12}>
                        <div style={{ display: "flex", gap: "8px" }}>
                        <Button
                            style={{ flex: 1 }}
                            onClick={() =>{
                                setExpiryDate(dayjs().add(14, "day"))
                                setLinkName("")
                                setSelectedUsers([])
                                setPermission(null)
                                setGeneratedLink("")
                            }
                            }
                            >
                            Cancel
                        </Button>
                        <Button
                            type="btn btn-sm btn-primary"
                            style={{ flex: 1, backgroundColor: "#007bff"}}
                            disabled={
                                !permission || 
                                !linkName || 
                                !expiryDate
                            }
                            onClick={() =>
                                {
                                    handleShare()
                                }            
                            }
                            >
                            Generate Link
                        </Button>
                        </div>
                        </Col>
                    </Row>
                    {generatedLink && (
                    <>
                        <Row gutter={8}>
                        <Col span={24}>
                            <div className="floating-field">
                            <span className="floating-label">Generated Link</span>

                            <div style={{ display: "flex", gap: "8px", height:"40px"}}>
                                <Input value={generatedLink} disabled />

                                <Button
                                onClick={() => {
                                    navigator.clipboard.writeText(generatedLink);
                                    message.success("Link Copied")
                                }}
                                >
                                Copy
                                </Button>
                            </div>
                            </div>
                        </Col>
                        </Row>
                        <Row><Col span={12}>Share Link via email</Col></Row>
                        <Row gutter={8}>
                            <Col span={12}>
                                <div className="floating-field">
                                <span className="floating-label">Select Contacts</span>
                                    <Select
                                        mode="multiple"
                                        placeholder="Select Contacts"
                                        value={selectedUsers}
                                        onChange={(val) => setSelectedUsers(val)}
                                        options={userOptions}
                                        style={{ width: "100%" }}
                                        showSearch
                                        optionFilterProp="label"
                                        labelInValue
                                    />
                                </div>
                            </Col>

                        <Col span={6}>
                        </Col>
                        <Col span={6}>
                            <Button
                            type="primary"
                            style={{ width: "100%", backgroundColor: "#007bff" }}
                            disabled={!selectedUsers.length}
                            onClick={() => handleSendEmail()}
                            >
                            Send Email
                            </Button>
                        </Col>
                        </Row>
                    </>
                    )}
            </div>
      </Modal>
    </>
    );
}

export default Workdrive;